import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../utils/constants';
import { IoHome, IoBarbell, IoBook, IoServer, IoSettings } from 'react-icons/io5';

export default function TabBar({ active, setActive }) {
  const { t } = useTranslation();
  const tabs = [
    { id: "home", icon: <IoHome size={22} />, label: t('nav.home') },
    { id: "gym", icon: <IoBarbell size={22} />, label: t('nav.gym') },
    { id: "recipes", icon: <IoBook size={22} />, label: t('nav.recipes') },
    { id: "base", icon: <IoServer size={22} />, label: t('nav.base') },
    { id: "settings", icon: <IoSettings size={22} />, label: t('nav.settings') },
  ];
  return (
    <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "rgba(20,16,30,0.85)", backdropFilter: "blur(24px)", borderTop: `1px solid rgba(255,255,255,0.06)`, display: "flex", justifyContent: "space-around", padding: `14px 0 calc(var(--sab, env(safe-area-inset-bottom, 0px)) + 14px)`, zIndex: 100, boxShadow: "0 -10px 30px rgba(0,0,0,0.5)" }}>
      {tabs.map(t => (
        <button key={t.id} onClick={() => setActive(t.id)} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 5, opacity: active === t.id ? 1 : 0.5, transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", transform: active === t.id ? "translateY(-4px)" : "translateY(0)" }}>
          <div style={{ color: active === t.id ? COLORS.accent : COLORS.textMuted, filter: active === t.id ? `drop-shadow(0 4px 8px ${COLORS.accent}60)` : "none", transition: "all 0.3s ease" }}>{t.icon}</div>
          <span style={{ fontSize: 11, color: active === t.id ? COLORS.accent : COLORS.textMuted, fontWeight: 700, letterSpacing: 0.3, fontFamily: "'Plus Jakarta Sans', sans-serif", transition: "color 0.3s ease" }}>{t.label}</span>
        </button>
      ))}
    </div>
  );
}
